import { useState } from "react";
import { IconButton, Tooltip } from "@mui/material";
import {
  ContentCopy as ContentCopyIcon,
  Check as CheckIcon,
} from "@mui/icons-material";

export default function CopyIconButton({ value, onCopy }) {
  const [copied, setCopied] = useState(false);
  const [fading, setFading] = useState(false);

  const handleCopy = () => {
    navigator.clipboard.writeText(value).catch(() => {});
    setCopied(true);
    onCopy?.();
    setTimeout(() => setFading(true), 1300);
    setTimeout(() => {
      setCopied(false);
      setFading(false);
    }, 1420);
  };

  const styles = {
    btn: {
      opacity: 0.35,
      transition: "opacity 0.12s",
      "&:hover": { opacity: 1 },
    },
    btnDone: {
      opacity: 1,
      transition: "opacity 0.12s",
    },
    btnFading: {
      opacity: 0,
      transition: "opacity 0.12s",
    },
  };

  const btnStyle = fading ? styles.btnFading : copied ? styles.btnDone : styles.btn;

  return (
    <Tooltip title={copied ? "" : "Copy link"}>
      <IconButton
        size="small"
        onClick={handleCopy}
        color={copied ? "success" : "default"}
        sx={btnStyle}
      >
        {copied ? <CheckIcon fontSize="small" /> : <ContentCopyIcon fontSize="small" />}
      </IconButton>
    </Tooltip>
  );
}
